<div class="container">
  <app-header class="header" [title]="'PAGES.TV_APPS' | translate"></app-header>
  <app-app-grid [config]="config"></app-app-grid>
  <app-app-name [config]="appnameconfig"></app-app-name>
  <app-app-logo [config]="applogoconfig"></app-app-logo>
  <app-app-description [config]="appdescriptionconfig"></app-app-description>
</div>
